import RecommendationsSectionInstructors from "./RecommendationsSectionInstructors";
export default RecommendationsSectionInstructors;
